export default "__VITE_ASSET__Cuc$ahRW__"